var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPajamasProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_766_6037)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 21.75L5.25 18V6L14.25 2.25V21.75ZM3.9225 19.884C3.64927 19.77 3.41588 19.5777 3.25172 19.3314C3.08756 19.085 2.99998 18.7956 3 18.4995V5.5005C2.99998 5.20445 3.08756 4.91501 3.25172 4.66864C3.41588 4.42227 3.64927 4.22998 3.9225 4.116L13.3845 0.1725C13.7265 0.0299901 14.0983 -0.0258727 14.4671 0.00987207C14.8358 0.0456168 15.1901 0.171863 15.4983 0.377401C15.8065 0.582938 16.0592 0.861407 16.234 1.18808C16.4087 1.51475 16.5001 1.87952 16.5 2.25V3H18.375C19.824 3 21 4.1745 21 5.625V18.375C21 19.0712 20.7234 19.7389 20.2312 20.2312C19.7389 20.7234 19.0712 21 18.375 21H16.5V21.75C16.5001 22.1205 16.4087 22.4852 16.234 22.8119C16.0592 23.1386 15.8065 23.4171 15.4983 23.6226C15.1901 23.8281 14.8358 23.9544 14.4671 23.9901C14.0983 24.0259 13.7265 23.97 13.3845 23.8275L3.9225 19.884ZM16.5 18.75H18.375C18.4745 18.75 18.5698 18.7105 18.6402 18.6402C18.7105 18.5698 18.75 18.4745 18.75 18.375V5.625C18.75 5.52554 18.7105 5.43016 18.6402 5.35983C18.5698 5.28951 18.4745 5.25 18.375 5.25H16.5V18.75Z",
    fill: "#ED583B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_766_6037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPajamasProject);
export default __webpack_public_path__ + "static/media/pajamas_project.b499f0780e5cc7835f41c98db3b6e192.svg";
export { ForwardRef as ReactComponent };